import { createI18n } from 'vue-i18n'
import { parseQuery } from 'vue-router'
import en from '../../lang/en.json'
import fr from '../../lang/fr.json'
import nl from '../../lang/nl.json'
import { Locale } from './global'
import { SupportedLocales } from './utils'

const lang = parseQuery(location.search).lang as string
const currencyFormat: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
}

export const i18n = createI18n({
    locale: SupportedLocales.includes(lang as Locale) ? lang : 'nl',
    messages: { en, fr, nl },
    numberFormats: Object.fromEntries(
        SupportedLocales.map((locale) => [locale, { currency: currencyFormat }])
    ),
    legacy: false,
    missingWarn: false,
})
